import { useQueryClient } from "@tanstack/react-query";
import { keys_comunication } from "@/api/space/hooks/useSpace.comunication";
import type { IGetComunicacaoQuantidadeNaoLidasResponse } from "@/api/space/dtos/comunication.dto";
import type { QuickPanelMessage } from "../quickPanel.types";
import { toQuickPanelMessage } from "../utils/quickPanelParsers";
import { useQuickPanelSocketEvent } from "./useQuickPanelSocketEvent";

// --------------------------------- TYPES ---------------------------------
type UseQuickPanelNotificationEventsParams = {
	readonly enabled?: boolean;
};

// ---------------------------------- HOOK ----------------------------------
export function useQuickPanelNotificationEvents({ enabled = true }: UseQuickPanelNotificationEventsParams): void {
	const queryClient = useQueryClient();

	function handlePersistentNotifications(messages: QuickPanelMessage[]) {
		queryClient.setQueryData<IGetComunicacaoQuantidadeNaoLidasResponse>(
			keys_comunication.quantidadeNaoLidas(),
			(currentData) => (currentData ? { quantidade: currentData.quantidade + messages.length } : currentData),
		);

		void queryClient.invalidateQueries({ queryKey: keys_comunication.listarNotificacoesBase() });
		void queryClient.invalidateQueries({ queryKey: keys_comunication.quantidadeNaoLidas() });
	}

	useQuickPanelSocketEvent({
		event: "notification:info",
		parse: toQuickPanelMessage("info"),
		onMessages: handlePersistentNotifications,
		enabled,
	});
	useQuickPanelSocketEvent({
		event: "notification:success",
		parse: toQuickPanelMessage("success"),
		onMessages: handlePersistentNotifications,
		enabled,
	});
	useQuickPanelSocketEvent({
		event: "notification:warning",
		parse: toQuickPanelMessage("warning"),
		onMessages: handlePersistentNotifications,
		enabled,
	});
	useQuickPanelSocketEvent({
		event: "notification:error",
		parse: toQuickPanelMessage("error"),
		onMessages: handlePersistentNotifications,
		enabled,
	});
}
